import { Typography } from 'antd';
import { TranslatableBox } from '../boxes/TranslatableBox';

export function AppParagraph({ as = Typography.Paragraph, ...rest }) {
  return <TranslatableBox {...rest} as={as} />;
}
